import {AxiosConfig} from "./AxiosConfig/AxiosConfig";
import {AxiosResponse} from "axios";
import {ILanguage} from "../Interfaces/Language";

const getLanguages = (): Promise<Array<ILanguage>> => {
    return new Promise<Array<ILanguage>>((resolve, reject) => {
        return AxiosConfig.instance.get("/languages").then((response: AxiosResponse) => {
            const languages: Array<ILanguage> = response.data ?? [];
            return resolve(languages);
        }).catch(error => {
            console.error(error)
            reject("Can't get languages");
        })
    })
}

const LanguageApi = {
    getLanguages
}

export default LanguageApi;